import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import Axios from "axios";
import { CopyrightComponent } from "./CopyrightComponent";


export class UploadImageToTaxonComponent implements IJSLComponent {

    private loading = false;
    private copyrightComp: CopyrightComponent;

    constructor(private taxonNr: number) {
        this.copyrightComp = new CopyrightComponent();
    }

    public render(): IJSLVNode {
        return <div>
            <h3>Weitere Bilder hochladen</h3>
            <input type="file" multiple />
            <div style="max-width:20rem; margin-left:auto; margin-right:auto;">{this.copyrightComp}</div>
            <button class="genric-btn" style={this.loading ? "visibility:hidden" : ""}
                click={(evt, node) => { this.upload(node.dom.parentElement.querySelector("input")); }}>
                hochladen</button>
            <p>&nbsp;</p>
        </div>;
    }

    private upload(el: HTMLInputElement) {
        const files = el.files;
        if (files.length > 0) {
            const imgformData = new FormData();
            for (let i = 0; i < files.length; i++) {
                imgformData.append("files", files[i]);
            }
            this.loading = true;
            Axios.post("api/admin/uploadimages?taxonId=" + this.taxonNr +
                "&copy=" + encodeURIComponent(this.copyrightComp.getValue() ?? ""), imgformData, {}).then(() => {
                    location.reload();
                }).catch((e) => {
                    this.loading = false;
                    alert("error: " + e.response.data.title);
                    refresh();
                });
        }
    }
}
